export const ids = {
  bookingModal: 'booking-modal',
  closeModalButton: 'close-modal-button',
  bookingTimeslots: 'booking-timeslots',
  bookingSubmitButton: 'booking-submit-button',
  bookingIinInput: 'booking-iin-input',
  bookingFioInput: 'booking-fio-input',
  bookingPhoneInput: 'booking-phone-input',
  bookingTimeSelectTrigger: 'booking-time-select-trigger',
  bookingTypeRadio: 'booking-type-radio',
  bookingBackButton: 'booking-back-button',
  bookingCloseOTPButton: 'booking-close-otp-button',
  bookingOTPPhoneNumber: 'booking-otp-phone-number',
  bookingOTPInput: 'booking-otp-input',
  bookingRepeatSMSButton: 'booking-repeat-sms-button',
  bookingTrigger: 'booking-trigger',
  bookingModalTitle: 'booking-modal-title',
};

export const doctorAliases = {
  /**
   * Используется для тестирования:
   * - Запись онлайн с preferred_time.
   * - Основная триггерная кнопка.
   * - ФИО, телефон и селект даты записи.
   */
  base: '1223993-yalymov-timur-ruslanovich',
  withTimeslots: '1224125-mazhenov-aybek-kuatovich',
};
